import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
    selector: 'app-image-highlighter-tooltip',
    templateUrl: './image-highlighter-tooltip.component.html',
    styleUrls: ['./image-highlighter-tooltip.component.less']
})
export class ImageHightlighterTooltipComponent implements OnInit {
    data: any;
    styleLeft: any;
    styleTop: any;

    constructor() { }

    ngOnInit() {
    }

}
